import { useEffect, useState } from 'react'
import Card from '../Card/Card'
import classes from './Refer.module.css'
import CopyIcon from '../../icon/CopyIcon'
import { InfoContainer } from '../Trading/components/AccountDetails/AccountDetails'
import RequestPayout from '../Trading/components/RequestPayout/RequestPayout'
import { env } from '../../constants/env'
import { useUser } from '../../context/UserContext'
import axios from 'axios'
import { toast } from 'react-toastify'



const historyData = [
    {
        date: "2023-11-24",
        email: "username@email.com",
        status: "Free",
        amount: "$0.00",
    },
    {
        date: "2023-11-24",
        email: "username@email.com",
        status: "Paid",
        amount: "$100.00",
    },
    {
        date: "2023-11-24",
        email: "username@email.com",
        status: "Paid",
        amount: "$100.00",
    },
    {
        date: "2023-11-24",
        email: "username@email.com",
        status: "Paid",
        amount: "$100.00",
    },
    {
        date: "2023-11-24",
        email: "username@email.com",
        status: "Paid",
        amount: "$100.00",
    },
    {
        date: "2023-11-24",
        email: "username@email.com",
        status: "Paid",
        amount: "$100.00",
    }
]

const Refer = () => {

     const [copyStatus, setCopyStatus] = useState("");

    const [withdraw, setWithdraw] = useState(false);
    const [withdrawalSuccess, setWithdrawalSuccess] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCommissions, setTotalCommissions] = useState(0);
    const [referrals, setReferrals] = useState([]);
    const [ranks, setRanks] = useState(0)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { user} = useUser();

    const limit = 10;

    const handleCopy = async (textToCopy) => {
        try {
          await navigator.clipboard.writeText(textToCopy);
          setCopyStatus("Text copied!");
          toast.success("Link copied!")
        } catch (err) {
          console.error("Failed to copy text: ", err);
          setCopyStatus("Failed to copy text.");
        }
      };


      const stats = [
        {
            title: "Referrals",
            number: referrals.length
        },
        {
            title: "Ranks",
            number: ranks
        },
        {
            title: "Balance",
            number: `$${totalCommissions}`
        }
    ]


      useEffect(() => {
        const fetchReferralsAndCommissions = async () => {
          // setLoading(true);
          setError(null);
          try {
            const response = await axios.get(`${env.apiUrl}/api/referrals`, {
              params: {
                page: currentPage,
                limit: limit,
              },
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            });
    
            setReferrals(response.data.referrals);
            console.log("REFERRAL AAAA", response.data)
            setTotalPages(response.data.totalPages);
            setRanks(response.data.ranks)
            const commissionsResponse = await axios.get(
              `${env.apiUrl}/api/commissions/total`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
              }
            );
            console.log("REFERRAL AAAA", commissionsResponse.data.total)
            setTotalCommissions(commissionsResponse.data.total);
          } catch (err) {
            setError(err.response?.data?.error || "Error fetching data");
          } finally {
            // setLoading(false);
          }
        };
    
        fetchReferralsAndCommissions();
      }, [currentPage]);

    return (
        <div className={classes.wrapper}>
            <div className='d-flex flex-column align-items-center gap-5'>
            <div className={classes.titleSection}>
            <h1>Refer & Earn</h1>
            <h3>You earn <span>15% of your friend’s challenge fees</span> Friends you refer get <span>10% discount</span></h3>
            </div>
           <div className={classes.statsSection}>
           <Card className={`${classes.cardWrapper} d-flex flex-column gap-4`}>
           <h3>Share your referral link</h3>
                <InfoContainer className={`${classes.inputInfo}`} textIconStyle={classes.textIconStyle} name={`${env.siteUrl}?referral-code=${user?.referralCode}`} text="Share" icon={<CopyIcon color="#30970B"  onClick={() => handleCopy(`${env.siteUrl}?referral-code=${user?.referralCode}`)} />} />
               
          </Card>
          <div className={classes.statsWrapper}>
           <div className={`row my-4 ${classes.statsRow}`}>
            {stats.map((item, i) => (<div className={`col-4`} key={i}>
                <Card className={`d-flex flex-column align-items-center ${classes.statsCard}`}>
                <h5>{item.title}</h5>
                <h3>{item.number}</h3>
                {i === stats.length - 1 && <div className={classes.withdrawalButton} role='button' onClick={() => (!withdraw && !withdrawalSuccess) && setWithdraw(true)}>Withdraw</div>}
                </Card>
            </div>))}
        </div>
        </div>
        <p>The minimum withdrawal threshold is $100. Referral  data is updated hourly, and withdrawals requested are automatically processed once the threshold is met</p>
         

                
            </div>
            </div>

            <div className={`mt-5`}>

      <h2>{(withdraw || withdrawalSuccess)  ? "Withdraw" : "Refferal history"}</h2>
      {withdraw && !withdrawalSuccess && <RequestPayout refer={true} profitAmount={totalCommissions} setWithdrawalSuccess={(value) => {setWithdraw(false); setWithdrawalSuccess(value)}}/>}
      {!withdraw && !withdrawalSuccess && <Card className={classes.historyCard}>
      <table className={classes.table}>
        <thead>
          <tr>
            <th className={classes.th}>Referral date</th>
            <th className={classes.th}>Referral email</th>
            <th className={classes.th}>Referral status</th>
            <th className={classes.th}>Commission Earned</th>
          </tr>
        </thead>
        <tbody>
        {referrals.length === 0 ? (<tr><td colSpan="5" className={classes.td}>No Referrals</td></tr>) :
          (<>{referrals.map((item, index) => (
            <tr key={index}>
              <td className={classes.td}>{item.date}</td>
              <td className={classes.td}>{item.email}</td>
              <td className={classes.td}>{item.status}</td>
              <td className={classes.td}>${item.amount}</td>
            </tr>
          ))}</>)}
        </tbody>
      </table>
      </Card>}
      {!withdraw && withdrawalSuccess && <div className="d-flex align-items-center justify-content-center">
          <div className={`d-flex flex-column align-items-center justify-content-center ${classes.successContainer}`}>
              <img src="/targets.svg"/>
              <p>Your withdrawal request has been submitted successfully!</p>
            </div>
          </div>}
      </div>
        </div>
    )
}

export default Refer